module.exports = __webpack_public_path__ + "img/sol_cap5.da78e3ce.png";